import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportCarburetion3Filters, getReportCarburetion3Action } from "redux/actions/Reports/reportCarburetion3/reportCarburetion3Actions";
import { useSearch } from "hooks/useSearch";

export const ReportCarburetion3View = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportCarburetion3);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportCarburetion3Action({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte de Carburación 3" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingCarburetion3
        ? <LoadingComponent />
        : <TableInputs
            reducer="reportCarburetion3"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportCarburetion3Filters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
      }
    </GlobalBox>
  );
};
